import React from 'react';
import { Box, css, palette, styled } from 'bumbag';

import { Link } from '@medipass/react-core/router';

import { TOUCH_MAX_BREAKPOINT } from '../../../constants';
const Tabs = styled.nav`
  display: flex;
  justify-content: space-between;
  height: 60px;
  min-height: 60px;
  width: 100%;
  background: white;
  border-top: 1px solid #e6e6e6;
  padding: 5px;
  font-size: 12px;
  z-index: 2;
  border-bottom: 1px solid ${palette('white900')};
  z-index: 10;

  @media screen and (min-width: ${TOUCH_MAX_BREAKPOINT + 1}px) {
    display: none;
  }
`;
const Tab = styled(Link)`
  flex: 1;
  padding-top: 5px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${palette('gray')};
  text-decoration: none;

  ${(props: any) =>
    window.location.pathname.includes(props.to) &&
    css`
      color: ${palette('secondary')(props)};
    `};
`;
const TabIcon = styled.i`
  font-size: 1.2rem;
`;
const TabContent = styled(Box)`
  margin-top: 2px;
`;
export default function TopTabNavigator() {
  return (
    <Tabs>
      <Tab to="/account/transactions/">
        <TabIcon className="fa fa-list-alt" />
        <TabContent>Activity</TabContent>
      </Tab>
      <Tab to="/account/quotes/">
        <TabIcon className="fa fa-envelope" />
        <TabContent>Quotes</TabContent>
      </Tab>
      <Tab to="/account/members/">
        <TabIcon className="fa fa-user" />
        <TabContent>Details</TabContent>
      </Tab>
      <Tab to="/account/payment-methods/">
        <TabIcon className="fa fa-credit-card" />
        <TabContent>Payment</TabContent>
      </Tab>
      <Tab to="/account/more/">
        <TabIcon className="fa fa-bars" />
        <TabContent>More</TabContent>
      </Tab>
    </Tabs>
  );
}
